import { css } from '@repo/pandacss/styled-system/css';
import { LinkType } from '@repo/segment/enums';
import type { AnalyticsType } from '@repo/segment/types';
import { EntityPlacementCtaTypeEnum } from '@repo/supergraph/marketplace/enums';
import type { CtaType } from '@repo/supergraph/marketplace/types';
import { CtaLink } from '../../CtaLink';

type CtaNameProps = {
  cta: CtaType;
  ctaAnalytics: AnalyticsType;
  displayName?: string;
};

export const CtaName = ({ cta, ctaAnalytics, displayName }: CtaNameProps) => {
  if (!cta) return null;

  return (
    <CtaLink
      cta={{ ...cta, type: EntityPlacementCtaTypeEnum.ProductName }}
      monetizable={ctaAnalytics.monetizable}
      analyticsPayload={ctaAnalytics}
      linkType={LinkType.PRODUCT_NAME}
      className={css({
        textStyle: 'boxHeadline',
        fontWeight: 'bold',
        color: 'neutral.black',
        textDecorationLine: 'none',
        display: 'block',
        _hover: {
          textDecorationLine: 'underline',
        },
      })}
    >
      {displayName}
    </CtaLink>
  );
};
